// Our main CSS
import '../css/app.css'
import { initGlideUp } from './Effects/glide.ts'
import { initTextWave } from './Effects/textWave.ts'
import { initScrollNavigation } from './modules/scroll-navigation.ts'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
const ExampleVueComponentWrapper = document.getElementById(
  'ExampleVueComponentWrapper'
)
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}
*/

/**
 * 🦄: Now do your magic.
 */

async function initAnimations(container: HTMLElement | Document = document) {
  await document.fonts.ready
  await new Promise((resolve) => requestAnimationFrame(resolve))

  initTextWave(['.wysiwyg h2', '.wysiwyg h3', '.wysiwyg h4', '[text-animation]'], container)
  initGlideUp({ container })
}

document.addEventListener('DOMContentLoaded', () => {
  initAnimations()
  initScrollNavigation()
})

const initNonCritical = async () => {
  // Lazy load video handling
  const autoplaying_videos = document.querySelectorAll<HTMLVideoElement>('video[playsinline]')
  if (autoplaying_videos?.length) {
    import('./modules/inline-videos').then(({ default: handleVideos }) => {
      handleVideos(autoplaying_videos)
    })
  }

  /*
    Intersecting elements helper
*/
  const check_intersecting = document.querySelectorAll(
    '[data-check-intersecting]'
  ) as NodeListOf<HTMLElement>

  if (check_intersecting?.length) {
    import('./modules/check-intersection').then(({ default: init }) => {
      init(check_intersecting)
    })
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}

const AllEmployeesComponentWrapper = document.querySelectorAll<HTMLElement>(
  '.AllEmployeesComponentWrapper'
)
if (AllEmployeesComponentWrapper && AllEmployeesComponentWrapper.length > 0) {
  import('./AllEmployees/index.ts')
    .then((module) => {
      AllEmployeesComponentWrapper.forEach((wrapper) => {
        module.default(wrapper as HTMLElement)
        initAnimations(wrapper)
      })
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const SingleEmployeeComponentWrapper = document.querySelectorAll<HTMLElement>(
  '.SingleEmployeeComponentWrapper'
)
if (SingleEmployeeComponentWrapper && SingleEmployeeComponentWrapper.length > 0) {
  import('./SingleEmployee/index.ts')
    .then((module) => {
      SingleEmployeeComponentWrapper.forEach((wrapper) => {
        module.default(wrapper as HTMLElement)
        initAnimations(wrapper)
      })
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const TeamsListWrapper = document.querySelectorAll<HTMLElement>('.TeamsListWrapper')
if (TeamsListWrapper && TeamsListWrapper.length > 0) {
  import('./TeamsList/index.ts')
    .then((module) => {
      TeamsListWrapper.forEach((wrapper) => {
        module.default(wrapper as HTMLElement)
        initAnimations(wrapper)
      })
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const VideoWrapper = document.querySelectorAll<HTMLElement>('.VideoWrapper')
if (VideoWrapper && VideoWrapper.length > 0) {
  import('./VideoComponent/index.ts')
    .then((module) => {
      VideoWrapper.forEach((wrapper) => {
        module.default(wrapper as HTMLElement)
        initAnimations(wrapper)
      })
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const AccordionComponentWrappers = document.querySelectorAll<HTMLElement>(
  '.AccordionComponentWrapper'
)
if (AccordionComponentWrappers && AccordionComponentWrappers.length > 0) {
  import('./AccordionComponent/index.ts')
    .then((module) => {
      AccordionComponentWrappers.forEach((wrapper) => {
        module.default(wrapper as HTMLElement)
        initAnimations(wrapper)
      })
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const TagsComponentWrapper = document.querySelectorAll<HTMLElement>('.TagsComponentWrapper')
if (TagsComponentWrapper && TagsComponentWrapper.length > 0) {
  import('./TagsComponent/index.ts')
    .then((module) => {
      TagsComponentWrapper.forEach((wrapper) => {
        module.default(wrapper as HTMLElement)
        initAnimations(wrapper)
      })
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const ArchiveProjectsWrapper = document.querySelectorAll<HTMLElement>('.ArchiveProjectsWrapper')
if (ArchiveProjectsWrapper && ArchiveProjectsWrapper.length > 0) {
  import('./ArchiveProjects/index.ts')
    .then((module) => {
      ArchiveProjectsWrapper.forEach((wrapper) => {
        module.default(wrapper as HTMLElement)
        initAnimations(wrapper)
      })
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const ProjectFiltersWrapper = document.querySelectorAll<HTMLElement>('.ProjectFiltersWrapper')
if (ProjectFiltersWrapper && ProjectFiltersWrapper.length > 0) {
  import('./ProjectFilters/index.ts')
    .then((module) => {
      ProjectFiltersWrapper.forEach((wrapper) => {
        module.default(wrapper as HTMLElement)
        initAnimations(wrapper)
      })
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const ArchiveNewsWrapper = document.querySelectorAll<HTMLElement>('.ArchiveNewsWrapper')
if (ArchiveNewsWrapper && ArchiveNewsWrapper.length > 0) {
  import('./ArchiveNews/index.ts')
    .then((module) => {
      ArchiveNewsWrapper.forEach((wrapper) => {
        module.default(wrapper as HTMLElement)
        initAnimations(wrapper)
      })
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

const button = document.getElementById('nav-icon')
const menu = document.getElementById('main-menu')
const overlay = document.createElement('div')
overlay.id = 'site-overlay'
document.body.appendChild(overlay)

function toggleMenu() {
  if (!button || !menu) {
    return
  }
  const expanded = button.getAttribute('aria-expanded') === 'true'

  button.setAttribute('aria-expanded', (!expanded).toString())

  document.body.classList.toggle('menu-open')

  if (document.body.classList.contains('menu-open')) {
    menu.removeAttribute('inert')
    menu.style.transform = 'translateX(0)'

    const firstFocusable = menu.querySelector<HTMLElement>(
      'a, button, [tabindex]:not([tabindex="-1"])'
    )
    firstFocusable?.focus()
  } else {
    menu.setAttribute('inert', '')
    menu.style.transform = 'translateX(-100%)'

    button.focus()
  }
}

button?.addEventListener('click', toggleMenu)

overlay.addEventListener('click', toggleMenu)

menu?.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', toggleMenu)
})

window.addEventListener(
  'scroll',
  () => {
    if (!button) {
      return
    }
    button.classList.toggle('scrolled', window.scrollY > 10)
  },
  { passive: true }
)
